import React, { Component } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container, FormControl, FormLabel, FormControlLabel, FormGroup, Switch, Tooltip } from '@mui/material'
import { QueuePlayNext } from '@mui/icons-material'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import Api from '../../services/api'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import * as Service from '../../services/calledservicesettings.service'
import Footer from '../../components/footer'
import { browserHistory } from '../../helpers/history'
import { FormattedMessage, injectIntl } from 'react-intl'
import Title from '../../components/title-name'
import { getAllSelectionModel } from '../../services/organization.service'
import { getAllSelectionModelCanCreateCalledByOrganizationId } from '../../services/organizationcategory.service'
import { getAllSelectionModelByOrganizationIdAndActiveAndtarget } from '../../services/organizationfield.service'
import { getAllSelectionModel as getAllTypesSelectionModel } from '../../services/type.service'
import { getAllSelectionModel as getAllOriginRequestsSelectionModel } from '../../services/originrequest.service'
import { getAllSelectionModel as getAllStatusSelectionModel } from '../../services/status.service'
import { getAllSelectionModel as getAllPrioritySelectionModel } from '../../services/priority.service'
import HelpIcon from '@mui/icons-material/Help'
import 'react-quill/dist/quill.snow.css'; // ES6
import ReactQuill from 'react-quill'; // ES6

class CalledServiceSettings extends Component {

  constructor(props) {
    super(props)
    const { userSession } = this.props

    this.globalAdm = false
    
    if (userSession.user.userrole == null) {
      Api.logoff()
    }

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype !== 3) {
        this.isClient = false
      }
      if (item.role.roletype === 0) {
        this.globalAdm = true
      }
    })

    this.reactQuillModules = {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
      ],
    }

    this.reactQuillFormats = [
      'header',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image'
    ]

    this.initialState = {
      id: 0,
      createdUser: userSession.user.id,
      updatedUser: userSession.user.id,
      hirerid: userSession.user.hirerid,
      createdAt: moment().format('YYYY/MM/DD HH:mm:ss'),
      updatedAt: moment().format('YYYY/MM/DD HH:mm:ss'),
      organizationId: 0,
      organizationCategoryId: 0,
      subjectId: 0,
      reasonId: 0,
      serviceId: 0,
      typeId: 0,
      originRequestId: 0,
      statusId: 0,
      priorityId: 0,
      validationofexistingcalleds: false,
      emailvalidationofexistingcalled: true,
      documentvalidationofexistingcalled: false,
      validationofexistingcalledmessage: ''
    }

    this.state = {
      item: this.initialState,
      OrganizationList: [],
      OrganizationCategoryList: [],
      SubjectList: [],
      ReasonList: [],
      ServiceList: [],
      TypeList: [],
      OriginRequestList: [],
      StatusList: [],
      PriorityList: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: ''
    }

    this.getCalledServiceSettings = this.getCalledServiceSettings.bind(this)
    this.getAllOrganizations = this.getAllOrganizations.bind(this)
    this.getAllTypes = this.getAllTypes.bind(this)
    this.getAllOriginRequests = this.getAllOriginRequests.bind(this)
    this.getAllStatus = this.getAllStatus.bind(this)
    this.getAllPriority = this.getAllPriority.bind(this)
    this.getAllOrganizationCategoriesByOrganizationId = this.getAllOrganizationCategoriesByOrganizationId.bind(this)
    this.getAllOrganizationFieldByOrganizationId = this.getAllOrganizationFieldByOrganizationId.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.closeNotification = this.closeNotification.bind(this)
    this.changeValues = this.changeValues.bind(this)
    this.handleChangeEditorAction = this.handleChangeEditorAction.bind(this)
    this.handleChangeSwitch = this.handleChangeSwitch.bind(this)
  }

  async componentDidMount() {
    await this.getCalledServiceSettings()
    await this.getAllTypes()
    await this.getAllOriginRequests()
    await this.getAllStatus()
    await this.getAllPriority()
    await this.getAllOrganizations()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount()
    }
  }

  getCalledServiceSettings = async () => {
    this.setState({ loading: true })
    let { userSession } = this.props

    if (userSession && userSession.user && userSession.user.hirerid && userSession.user.hirerid > 0) {
      let result = await Service.getByHirerId(userSession.user.hirerid)
        if(result && result.success) {
          if (result.data && result.data.id && result.data.id > 0) {
            let itemData = {
              id: result.data.id && result.data.id > 0 ? result.data.id : 0,
              organizationId: result.data.organization && result.data.organization.id ? result.data.organization : 0,
              organizationCategoryId: result.data.organizationcategory && result.data.organizationcategory.id ? result.data.organizationcategory : 0,
              subjectId: result.data.subject && result.data.subject.id ? result.data.subject : 0,
              reasonId: result.data.reason && result.data.reason.id ? result.data.reason : 0,
              serviceId: result.data.service && result.data.service.id ? result.data.service : 0,
              typeId: result.data.type && result.data.type.id ? result.data.type : 0,
              originRequestId: result.data.originrequest && result.data.originrequest.id ? result.data.originrequest : 0,
              statusId: result.data.status && result.data.status.id ? result.data.status : 0,
              priorityId: result.data.priority && result.data.priority.id ? result.data.priority : 0,
              validationofexistingcalleds: result.data.validationofexistingcalleds != null ? result.data.validationofexistingcalleds : true,
              emailvalidationofexistingcalled: result.data.emailvalidationofexistingcalled != null ? result.data.emailvalidationofexistingcalled : true,
              documentvalidationofexistingcalled: result.data.documentvalidationofexistingcalled != null ? result.data.documentvalidationofexistingcalled : false,
              validationofexistingcalledmessage: result.data.validationofexistingcalledmessage != null ? result.data.validationofexistingcalledmessage : ''
            }

            this.setState(prevState => ({
              item: {
                ...prevState.item,
                ...itemData
              }
            }))

            if (result.data.organization && result.data.organization.id) {
              this.getAllOrganizationCategoriesByOrganizationId(result.data.organization.id)
              this.getAllOrganizationFieldByOrganizationId(result.data.organization.id)
            }
          }
        } else {
          const intl = this.props.intl
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
    }
  }

  getAllOrganizations = async _ => {
    let result = await getAllSelectionModel()
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ OrganizationList: result.data })
      }
      this.setState({ loading: false })
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  getAllTypes = async _ => {
    let result = await getAllTypesSelectionModel()
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ TypeList: result.data })
      }
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  getAllOriginRequests = async _ => {
    let result = await getAllOriginRequestsSelectionModel()
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ OriginRequestList: result.data })
      }
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  getAllStatus = async _ => {
    let result = await getAllStatusSelectionModel()
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ StatusList: result.data })
      }
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  getAllPriority = async _ => {
    let result = await getAllPrioritySelectionModel()
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ PriorityList: result.data })
      }
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  getAllOrganizationCategoriesByOrganizationId = async (orgId) => {
    this.setState({ loading: true })

    let result = await getAllSelectionModelCanCreateCalledByOrganizationId(orgId)
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ OrganizationCategoryList: result.data })
      }
      this.setState({ loading: false })
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  getAllOrganizationFieldByOrganizationId = async (orgId) => {

    let result = await getAllSelectionModelByOrganizationIdAndActiveAndtarget(orgId)
    if(result && result.success) {
      if (result.data != null) {
        this.setState({ SubjectList: result.data, ReasonList: result.data, ServiceList: result.data })
      }
      this.setState({ loading: false })
    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  handleInputChange = e => {
    const name = e.target.name
    const value = e.target.value

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: value
      }
    }))
  }

  handleChangeEditorAction = value => {
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        validationofexistingcalledmessage: value
      }
    }))
  }

  handleChangeSwitch = (e) => {
    let { name, checked } = e.target

    if (name === 'emailvalidationofexistingcalled') {
      this.setState(prevState => ({
        item: {
          ...prevState.item,
          documentvalidationofexistingcalled: checked ? false : true
        }
      }))
    } else if (name === 'documentvalidationofexistingcalled') {
      this.setState(prevState => ({
        item: {
          ...prevState.item,
          emailvalidationofexistingcalled: checked ? false : true
        }
      }))
    }

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [name]: checked
      }
    }))
  }

  handleSubmit = async e => {
      e.preventDefault()
      let { item } = this.state

      this.setState({ loading: true })

      let data = new FormData()
      
        this.setState(prevState => ({
          item: {
            ...prevState.item,
          }
        }))

        for (let key in item) {
          if(key.toString().toLowerCase().indexOf('createduser') > -1 || key.toString().toLowerCase().indexOf('updateduser') > -1) {
            data.append(key, item[key])
          } else if(key.toString().toLowerCase().indexOf('createdat') > -1 || key.toString().toLowerCase().indexOf('updatedat') > -1) {
            data.append(key, moment(item[key]).format('YYYY/MM/DD HH:mm:ss'))
          } else if (key.toString().endsWith('Id')) {
            if (item[key] && item[key].id && item[key].id > 0)
              data.append(key, item[key].id)
            else if (item[key] && item[key] > 0)
              data.append(key, item[key])
          } else {
            data.append(key, item[key])
          }
        }

        let result = item.id > 0 ? await Service.editItem(data) : await Service.addItem(data)
        if(result && result.success) {
          const intl = this.props.intl;
          this.setState(prevState => ({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: item.id > 0 ? intl.formatMessage({ id: "edit.success" }) : intl.formatMessage({ id: "add.success" }),
            item: {
              ...prevState.item,
              id: result.data.id
            }
          }))
        } else {
          const intl = this.props.intl
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(result)
        }
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  changeValues(stateName, value, text = '') {

    if (stateName === 'organizationId' && value && value.id && value.id > 0) {
      this.getAllOrganizationCategoriesByOrganizationId(value.id)
      this.getAllOrganizationFieldByOrganizationId(value.id)
    }

    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [stateName]: value
      }
    }))
  }

  render() {
    const { classes, headerMenu } = this.props;
    const { item } = this.state;
    const intl = this.props.intl;

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          })}>
        <div className={classes.drawerHeader} />
        <Container component='main' maxWidth='md'>
          <CssBaseline />
          <div className={classes.paper} style={{ marginTop: 0 }}>
            <Grid container spacing={6}>
              <Grid item xs={12} sm={4}>
                <Button variant='outlined' color='primary' onClick={browserHistory.goBack}>{<FormattedMessage id="back" />}</Button>
              </Grid>
              <Grid item xs={12} sm={8} />
            </Grid>
            <Avatar className={classes.avatar}>
              <QueuePlayNext />
            </Avatar>
            <Typography component='h1' variant='h5'>
              {<FormattedMessage id="called.service.settings" />}
              <Title />
            </Typography>
            <form name='myForm' className={classes.form} onSubmit={this.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "organization" })}
                      options={this.state.OrganizationList}
                      stateName='organizationId'
                      changeSelect={this.changeValues}
                      selected={item.organizationId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "category" })}
                      options={this.state.OrganizationCategoryList}
                      stateName='organizationCategoryId'
                      changeSelect={this.changeValues}
                      selected={item.organizationCategoryId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "subject" })}
                      options={this.state.SubjectList}
                      stateName='subjectId'
                      changeSelect={this.changeValues}
                      selected={item.subjectId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "reason" })}
                      options={this.state.ReasonList}
                      stateName='reasonId'
                      changeSelect={this.changeValues}
                      selected={item.reasonId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "service" })}
                      options={this.state.ServiceList}
                      stateName='serviceId'
                      changeSelect={this.changeValues}
                      selected={item.serviceId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "type" })}
                      options={this.state.TypeList}
                      stateName='typeId'
                      changeSelect={this.changeValues}
                      selected={item.typeId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "origin.request" })}
                      options={this.state.OriginRequestList}
                      stateName='originRequestId'
                      changeSelect={this.changeValues}
                      selected={item.originRequestId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "menu.statuses" })}
                      options={this.state.StatusList}
                      stateName='statusId'
                      changeSelect={this.changeValues}
                      selected={item.statusId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Grid item xs={11} sm={11}>
                    <SimpleAutoComplete
                      label={intl.formatMessage({ id: "priority" })}
                      options={this.state.PriorityList}
                      stateName='priorityId'
                      changeSelect={this.changeValues}
                      selected={item.priorityId}
                       />
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">
                      <FormattedMessage id="called.service.settings.validation" />
                    </FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch 
                            checked={item.validationofexistingcalleds}
                            onChange={this.handleChangeSwitch}
                            name="validationofexistingcalleds" />
                        }
                        label={intl.formatMessage({ id:"called.service.settings.existing.called.validation" })} />
                    </FormGroup>
                  </FormControl>
                </Grid>
                {item.validationofexistingcalleds == true && <Grid item xs={1} sm={1} style={{ paddingTop: 0 }} />}
                {item.validationofexistingcalleds == true && <Grid item xs={10} sm={6} style={{ paddingTop: 0 }} >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch 
                          checked={item.emailvalidationofexistingcalled}
                          onChange={this.handleChangeSwitch}
                          name="emailvalidationofexistingcalled" />
                      }
                      label={intl.formatMessage({ id:"called.service.settings.mail.existing.called.validation" })} />
                  </FormGroup>
                </Grid>}
                {item.validationofexistingcalleds == true && <Grid item xs={1} sm={5} style={{ textAlign: 'left', alignSelf: 'stretch', paddingTop: 0 }}>
                  <Tooltip title={<h5>{intl.formatMessage({id:"called.service.settings.mail.existing.called.validation.helper"})}</h5>}>
                    <HelpIcon />
                  </Tooltip>
                </Grid>}
                {item.validationofexistingcalleds == true && <Grid item xs={1} sm={1} style={{ paddingTop: 0 }} />}
                {item.validationofexistingcalleds == true && <Grid item xs={10} sm={6} style={{ paddingTop: 0 }} >
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch 
                          checked={item.documentvalidationofexistingcalled}
                          onChange={this.handleChangeSwitch}
                          name="documentvalidationofexistingcalled" />
                      }
                      label={intl.formatMessage({ id:"called.service.settings.document.existing.called.validation" })} />
                  </FormGroup>
                </Grid>}
                {item.validationofexistingcalleds == true && <Grid item xs={1} sm={5} style={{ textAlign: 'left', alignSelf: 'stretch', paddingTop: 0 }}>
                  <Tooltip title={<h5>{intl.formatMessage({id:"called.service.settings.document.existing.called.validation.helper"})}</h5>}>
                    <HelpIcon />
                  </Tooltip>
                </Grid>}
                {item.validationofexistingcalleds == true && <Grid item xs={10} sm={10}>
                  <Typography>
                    <FormattedMessage id="called.service.settings.existing.called.validation.message" />
                  </Typography>
                  <ReactQuill
                    id="validationofexistingcalledmessage"
                    name="validationofexistingcalledmessage"
                    modules={this.reactQuillModules}
                    formats={this.reactQuillFormats}
                    value={item.validationofexistingcalledmessage}
                    style={{ height: 200 }}
                    fullWidth
                    required
                    InputLabelProps={{ shrink: item.validationofexistingcalledmessage && item.validationofexistingcalledmessage.length > 0 ? true : false }}
                    variant="outlined"
                    onChange={this.handleChangeEditorAction} />
                </Grid>}
                {item.validationofexistingcalleds == true && <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', paddingTop: 0 }}>
                  <Tooltip title={<h5>{intl.formatMessage({id:"called.service.settings.existing.called.validation.message.helper"})}</h5>}>
                    <HelpIcon />
                  </Tooltip>
                </Grid>}
                <Grid item xs={12} sm={12} style={{ marginTop: 30, display: 'flex', justifyContent: 'flex-end' }}>
                  <Grid container justify="flex-end" spacing={2} style={{ justifyContent: 'flex-end' }}>
                    <Grid item xs={12} sm={4}    >
                      <Button 
                        type='submit'
                        fullWidth
                        variant='contained'
                        color='primary'
                        className={classes.submit} >
                        {<FormattedMessage id="save" />}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </div>
          {this.state.loading && (
            <Overlay>
              <CircularProgress color='secondary' />
            </Overlay>
          )}
          <CustomizedSnackbars
            variant={this.state.notificationVariant}
            message={this.state.notificationMessage}
            isOpen={this.state.openNotification}
            toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

CalledServiceSettings.propTypes = { classes: PropTypes.object.isRequired };

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});

export default injectIntl(connect(mapStateToProps)(withStyles(Styles)(CalledServiceSettings)));